import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  id: "navigationPlaceholder",
  style: {"padding-top":"80px"}
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-7" }
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "container" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-2 order-2 text-center" }
const _hoisted_9 = {
  key: 0,
  class: "fa fa-arrow-circle-right fa-2x",
  title: "From connector to dataset"
}
const _hoisted_10 = {
  key: 1,
  class: "fa fa-arrow-circle-right fa-2x",
  title: "From dataset to connector"
}
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "input-group-prepend" }
const _hoisted_13 = { class: "input-group-text" }
const _hoisted_14 = ["onUpdate:modelValue"]
const _hoisted_15 = { class: "input-group-append" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "input-group-prepend" }
const _hoisted_18 = { class: "input-group-text" }
const _hoisted_19 = ["onUpdate:modelValue"]
const _hoisted_20 = { class: "input-group-append" }
const _hoisted_21 = ["onClick"]

import { computed, ref, watch, onMounted, onUnmounted } from 'vue'
    import { useId, useOrganizationUnitId } from '@common/composables'
    import { useAdminConfigurePipelineIdsPage } from '@Integrations/Pipelines/pages-core'
    import AdminNavigationV2 from '@common/AdminNavigationV2.vue'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'AdminConfigurePipelineIdsPage',
  setup(__props) {

    document.title = "Configure IDs"

    const tid = useOrganizationUnitId()
    const id = useId()

    const connectorId = ref()

    const idPropertyNameForConnector = ref()
    const idPropertyNameForDataset = ref()

    const idPropertyNamesForConnector = ref([])
    const idPropertyNamesForDataset = ref([])

    const nameForConnector = ref()
    const nameForDataset = ref()

    const {
        useCurrentUserQuery,
        usePipelineDetailsQuery,
        useConnectorPropertyNamesQuery,
        useChangeIdPropertyNamesForConnectorCommand,
        useChangeIdPropertyNamesForDatasetCommand
    } = useAdminConfigurePipelineIdsPage()

    const { modelCurrentUserQueryV1, runCurrentUserQueryV1 } = useCurrentUserQuery()
    const userId = computed(() => modelCurrentUserQueryV1.value?.UserId)

    const { runPipelineDetailsQueryV1, modelPipelineDetailsQueryV1 } = usePipelineDetailsQuery(id)
    const direction = computed(() => modelPipelineDetailsQueryV1.value?.Direction)
    const mappings = computed(() => modelPipelineDetailsQueryV1.value?.Mappings || [])

    const { dataStream, runConnectorPropertyNamesQueryV1, modelConnectorPropertyNamesQueryV1 } = useConnectorPropertyNamesQuery(connectorId)
    const propertyNames = computed(() => modelConnectorPropertyNamesQueryV1.value?.PropertyNames || [])

    const { invokeChangeIdPropertyNamesForConnectorCommandV1, succeedChangeIdPropertyNamesForConnectorCommandV1 } = useChangeIdPropertyNamesForConnectorCommand(id, tid, userId, idPropertyNamesForConnector)
    const { invokeChangeIdPropertyNamesForDatasetCommandV1, succeedChangeIdPropertyNamesForDatasetCommandV1 } = useChangeIdPropertyNamesForDatasetCommand(id, tid, userId, idPropertyNamesForDataset)

    function handleAddPropertyNameMappingCommand() {
        invokeAddPropertyNameMappingCommandV1()
    }

    function handleRemovePropertyNameMappingCommandV1(mapping: any) {
        invokeRemovePropertyNameMappingCommandV1({
            nameForConnector: mapping.NameForConnector,
            nameForDataset: mapping.NameForDataset,
        })
    }

    function handleAddIdPropertyNameForConnector() {
        idPropertyNamesForConnector.value.push("")
    }

    function handleRemoveIdPropertyNameForConnector(index: number) {
        idPropertyNamesForConnector.value.splice(index, 1)
    }

    function handleAddIdPropertyNameForDataset() {
        idPropertyNamesForDataset.value.push("")
    }

    function handleRemoveIdPropertyNameForDataset(index: number) {
        idPropertyNamesForDataset.value.splice(index, 1)
    }

    watch(modelPipelineDetailsQueryV1, () => {
        connectorId.value = modelPipelineDetailsQueryV1.value.ConnectorId
        dataStream.value = modelPipelineDetailsQueryV1.value.DataStream
        idPropertyNameForConnector.value = modelPipelineDetailsQueryV1.value.IdPropertyNameForConnector ?? 'Id'
        idPropertyNameForDataset.value = modelPipelineDetailsQueryV1.value.IdPropertyNameForDataset ?? 'Id'
        idPropertyNamesForConnector.value = modelPipelineDetailsQueryV1.value.IdPropertyNamesForConnector ?? ['Id']
        idPropertyNamesForDataset.value = modelPipelineDetailsQueryV1.value.IdPropertyNamesForDataset ?? ['Id']
    })

    watch(connectorId, () => runConnectorPropertyNamesQueryV1())

    onMounted(() => {
        runCurrentUserQueryV1()
        runPipelineDetailsQueryV1()
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(AdminNavigationV2, { tid: _unref(tid) }, null, 8 /* PROPS */, ["tid"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[3] || (_cache[3] = _createElementVNode("h1", { style: {"font-size":"2em","font-weight":"300","color":"#33475b"} }, "Configure IDs", -1 /* CACHED */)),
          _createElementVNode("a", {
            href: `/#/admin/integrations/pipelines/details/${_unref(tid)}/${_unref(id)}`,
            type: "button",
            class: "btn btn-link btn-sm"
          }, [...(_cache[2] || (_cache[2] = [
            _createElementVNode("i", {
              class: "fa fa-arrow-left",
              "aria-hidden": "true"
            }, null, -1 /* CACHED */),
            _createTextVNode(" Back ", -1 /* CACHED */)
          ]))], 8 /* PROPS */, _hoisted_5)
        ]),
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "col-lg-5 col-sm-6 text-right" }, null, -1 /* CACHED */))
      ])
    ]),
    _cache[10] || (_cache[10] = _createElementVNode("hr", { style: {"border-color":"#bbb","margin":"20px 0 30px"} }, null, -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", {
          class: _normalizeClass(["col-5 text-right", { 'order-1': direction.value==1, 'order-3': direction.value==2 }])
        }, [...(_cache[5] || (_cache[5] = [
          _createElementVNode("h5", null, "Connector", -1 /* CACHED */)
        ]))], 2 /* CLASS */),
        _createElementVNode("div", _hoisted_8, [
          (direction.value==1)
            ? (_openBlock(), _createElementBlock("i", _hoisted_9))
            : _createCommentVNode("v-if", true),
          (direction.value==2)
            ? (_openBlock(), _createElementBlock("i", _hoisted_10))
            : _createCommentVNode("v-if", true)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["col-5", { 'order-1': direction.value==2, 'order-3': direction.value==1 }])
        }, [...(_cache[6] || (_cache[6] = [
          _createElementVNode("h5", null, "Dataset", -1 /* CACHED */)
        ]))], 2 /* CLASS */)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", {
          class: _normalizeClass(["col-5 text-right", { 'order-1': direction.value==1, 'order-3': direction.value==2 }])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(idPropertyNamesForConnector.value, (idPropertyNameForConnector, idx) => {
            return (_openBlock(), _createElementBlock("div", {
              key: idx,
              class: "input-group mb-1"
            }, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("span", _hoisted_13, "ID" + _toDisplayString(idx+1), 1 /* TEXT */)
              ]),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": ($event: any) => ((idPropertyNamesForConnector.value[idx]) = $event),
                type: "text",
                class: "form-control"
              }, null, 8 /* PROPS */, _hoisted_14), [
                [
                  _vModelText,
                  idPropertyNamesForConnector.value[idx],
                  void 0,
                  { trim: true }
                ]
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("button", {
                  onClick: ($event: any) => (handleRemoveIdPropertyNameForConnector(idx)),
                  class: "btn btn-danger btn-sm"
                }, [...(_cache[7] || (_cache[7] = [
                  _createElementVNode("i", { class: "fa-regular fa-trash-can" }, null, -1 /* CACHED */)
                ]))], 8 /* PROPS */, _hoisted_16)
              ])
            ]))
          }), 128 /* KEYED_FRAGMENT */)),
          _createElementVNode("button", {
            onClick: handleAddIdPropertyNameForConnector,
            class: "btn btn-sm"
          }, "Add"),
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(invokeChangeIdPropertyNamesForConnectorCommandV1) && _unref(invokeChangeIdPropertyNamesForConnectorCommandV1)(...args))),
            class: "btn btn-outline-secondary",
            type: "button"
          }, "Save")
        ], 2 /* CLASS */),
        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "col-2 order-2 text-center" }, null, -1 /* CACHED */)),
        _createElementVNode("div", {
          class: _normalizeClass(["col-5", { 'order-1': direction.value==2, 'order-3': direction.value==1 }])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(idPropertyNamesForDataset.value, (idPropertyNameForDataset, idx) => {
            return (_openBlock(), _createElementBlock("div", {
              key: idx,
              class: "input-group mb-1"
            }, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("span", _hoisted_18, "ID" + _toDisplayString(idx+1), 1 /* TEXT */)
              ]),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": ($event: any) => ((idPropertyNamesForDataset.value[idx]) = $event),
                type: "text",
                class: "form-control"
              }, null, 8 /* PROPS */, _hoisted_19), [
                [
                  _vModelText,
                  idPropertyNamesForDataset.value[idx],
                  void 0,
                  { trim: true }
                ]
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("button", {
                  onClick: ($event: any) => (handleRemoveIdPropertyNameForDataset(idx)),
                  class: "btn btn-danger btn-sm"
                }, [...(_cache[8] || (_cache[8] = [
                  _createElementVNode("i", { class: "fa-regular fa-trash-can" }, null, -1 /* CACHED */)
                ]))], 8 /* PROPS */, _hoisted_21)
              ])
            ]))
          }), 128 /* KEYED_FRAGMENT */)),
          _createElementVNode("button", {
            onClick: handleAddIdPropertyNameForDataset,
            class: "btn btn-sm"
          }, "Add"),
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(invokeChangeIdPropertyNamesForDatasetCommandV1) && _unref(invokeChangeIdPropertyNamesForDatasetCommandV1)(...args))),
            class: "btn btn-outline-secondary",
            type: "button"
          }, "Save")
        ], 2 /* CLASS */)
      ])
    ])
  ]))
}
}

})